<template>
  <div :class="`typeservice ${css}`" v-if="show">
    <label>Tipo de Serviço</label>
    <br />
    <SelectFilter :list="list" @value="(item) => update(item)" 
      :name="'nome'" :css="'grid-2-g grid-10-m grid-10-s'"
      :text="text"
      required />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SelectFilter from "@/components/select/SelectFilter";

export default {
  name: "ServiceType",
  props: {
    client: Number,
    css: String,
    text: String,
    tipo: String,
    forma_atendimento: String,
    id_base_custo: Number
  },
  components: { SelectFilter },
  data() {
    return {
      show: false,
      list: [],
    };
  },
  methods: {
    ...mapActions("client", ["SERVICES_TYPE_LIST"]),
    ...mapActions("admin", ["SERVICESTYPE_LIST"]),
    update(item) {
      this.$emit("value", item);
    },
  },
  beforeMount() {
    let pay = { status: 'ativo' }
    if (this.client) {
      pay.id_cliente = this.client
      this.SERVICES_TYPE_LIST(pay).then(({ data }) => {
        this.list = data || [];
        if (data && data.length) this.show = true;
      });
    }
    if (this.forma_atendimento && this.tipo && this.id_base_custo) {
      pay.id_base_custo = this.id_base_custo
      pay.tipo = this.tipo
      pay.forma_atendimento = this.forma_atendimento
      this.SERVICESTYPE_LIST(pay).then(({ data }) => {
        this.list = data || [];
        if (data && data.length) this.show = true;
      });
    }
  },
};
</script>
